import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, Download, Heart, Share2, ShieldCheck } from "lucide-react";

import { Button } from "@/components/ui/button";

import { siteConfig } from "../config/site";
function Rule() {
  return <div className="h-px w-full bg-border/60" />;
}

export function HomePage() {
  return (
    <>
      <Helmet>
        <title>{siteConfig.title}</title>
        <meta name="description" content={siteConfig.description} />
      </Helmet>

      <section className="space-y-10 pb-14">
        <div className="space-y-5">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            passwords · passkeys · more to come
          </p>
          <h1 className="max-w-3xl font-display text-5xl leading-[1.02] tracking-tight sm:text-6xl">
            A safe place for your sensitive stuff.
          </h1>
          <p className="max-w-2xl text-lg leading-relaxed text-muted-foreground">
            key.store keeps your passwords secure. We collect as little as possible. Read the{" "}
            <Link to="/privacy" className="underline underline-offset-4 hover:text-foreground">
              privacy policy
            </Link>
            .
          </p>

          <div className="flex flex-wrap items-center gap-4 pt-2">
            <Button asChild size="lg" className="gap-2 rounded-full pl-5 pr-6">
              <Link to="/download">
                <Download className="h-4 w-4" />
                Download
              </Link>
            </Button>
            <a
              href={siteConfig.links.repo}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            >
              Read the code <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-3">
          <div className="rounded-2xl border border-border/60 p-6">
            <p className="flex items-center gap-2 font-mono text-xs text-muted-foreground">
              <Heart className="h-3.5 w-3.5" />
              free forever
            </p>
            <p className="mt-3 font-display text-xl tracking-tight">All features. Forever.</p>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              No upsells. Export anytime.
            </p>
          </div>
          <div className="rounded-2xl border border-border/60 p-6">
            <p className="flex items-center gap-2 font-mono text-xs text-muted-foreground">
              <ShieldCheck className="h-3.5 w-3.5" />
              safe by design
            </p>
            <p className="mt-3 font-display text-xl tracking-tight">Your data stays yours</p>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              End-to-end encrypted. Open source. We collect as little as possible.
            </p>
          </div>
          <div className="rounded-2xl border border-border/60 p-6">
            <p className="flex items-center gap-2 font-mono text-xs text-muted-foreground">
              <Share2 className="h-3.5 w-3.5" />
              sharing built in
            </p>
            <p className="mt-3 font-display text-xl tracking-tight">Share without texting passwords</p>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">Family and work.</p>
          </div>
        </div>
      </section>

      <Rule />

      <section className="space-y-3 py-14">
        <h2 className="font-display text-3xl tracking-tight sm:text-4xl">
          Stop saving passwords in five places.
        </h2>
        <p className="max-w-2xl text-muted-foreground">
          One place, every device. Desktop today, mobile next.{" "}
          <Link to="/download" className="underline underline-offset-4 hover:text-foreground">
            See downloads
          </Link>
          .
        </p>
      </section>
    </>
  );
}
